<div class="flex flex-1 justify-center items-center">
	<router-outlet class="hidden-router"></router-outlet>
</div>
